import type { SxProps, Theme } from "@mui/material";

export const STATUS_CHIP_SX = {
  width: "fit-content",
  height: `22px`,
  lineHeight: "22px",
  borderRadius: 1,
  border: "1px solid",
  background: "none",

  "& .MuiChip-label": {
    display: "flex",
    alignItems: "center",
    minWidth: "min-content",
    gap: 1,
    // color: "color-mix(in srgb, var(--base-color), currentColor 50%)",
    paddingRight: 1,
    paddingLeft: 1,
    fontSize: `1.1em`,
  },
} as SxProps<Theme>;

export const MAP_STATUS_TO_LABEL = {
  complete_with_retries: "+ Retries",
  error_with_retries: "+ Retries",
};

export const RUN_STATUS_BAR_CLASS = "w-2! h-2!";

export const MAX_RUNS = 3;
